import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { LayoutModule } from '../components/layout/layout.module';
import { MyModalModule } from '../components/modal/modal.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutAuthComponent } from './Auth/auth.component';
import { LayoutAppComponent } from './App/app.component';
import { LayoutSettingComponent } from './Setting/setting.component';

const COMPONENTS = [LayoutAuthComponent, LayoutAppComponent, LayoutSettingComponent];

@NgModule({
  imports: [SharedModule, LayoutModule, MyModalModule, FormsModule, ReactiveFormsModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class LayoutsModule {}
